<ng-container *ngIf="eventsFeed">
  <article *ngFor="let event of eventsFeed">
    <label>{{ event.timestamp | date: 'MMMM D, YYYY hh:mm A' }}</label>
    <p class="normal"><span [innerHTML]="event.action"></span>
      &nbsp;{{ 'activityFeed.by' | translate }}&nbsp;
      <strong>{{ event.user.name }}</strong>
    </p>
  </article>
</ng-container>